/* global axios */
import ApiClient from './ApiClient';

class InboxMetaAPI extends ApiClient {
  constructor() {
    super('inboxmeta', { accountScoped: false });
  }

  load() {
    return axios.get(`${this.url}/load`);
  }

  fetchAgentis(inboxId) {
    return axios.get(`${this.url}/fetch_agentis`, {
      params: { inbox_id: inboxId }
    });
  }

  validateWhatsAppNumbers(inboxId, numbers) {
    return axios.post(`${this.url}/validate_whatsapp_numbers`, {
      inbox_id: inboxId,
      numbers,
    });
  }

  updateMeta(inboxId, data) {
    return axios.post(`${this.url}/update_meta`, {
      inbox_id: inboxId,
      ...data
    });
  }

  fetchEvolutionGroups(inboxId) {
    return axios.get(`${this.url}/fetch_evolution_groups`, {
      params: { inbox_id: inboxId },
    });
  }
}

export default new InboxMetaAPI();